export function loggError(error: Error) {
  console.error(error);
}
